import { FileAccess } from '../../../../base/common/network.js';
import { localize } from '../../../../nls.js';
var ExtensionInstallLocation;
( ((function(ExtensionInstallLocation) {
    ExtensionInstallLocation[ExtensionInstallLocation["Local"] = 1] = "Local";
    ExtensionInstallLocation[ExtensionInstallLocation["Remote"] = 2] = "Remote";
    ExtensionInstallLocation[ExtensionInstallLocation["Web"] = 3] = "Web";
})(ExtensionInstallLocation || (ExtensionInstallLocation = {}))));
const getDefaultIconPath = () => ( (( (FileAccess.asBrowserUri('vs/workbench/services/extensionManagement/common/media/defaultIcon.png'))).toString(true)));
const extensionsConfigurationNodeBase = {
    id: 'extensions',
    order: 30,
    title: ( localize(7542, "Extensions")),
    type: 'object'
};
var EnablementState;
( ((function(EnablementState) {
    EnablementState[EnablementState["DisabledByTrustRequirement"] = 0] = "DisabledByTrustRequirement";
    EnablementState[EnablementState["DisabledByExtensionKind"] = 1] = "DisabledByExtensionKind";
    EnablementState[EnablementState["DisabledByEnvironment"] = 2] = "DisabledByEnvironment";
    EnablementState[EnablementState["EnabledByEnvironment"] = 3] = "EnabledByEnvironment";
    EnablementState[EnablementState["DisabledByVirtualWorkspace"] = 4] = "DisabledByVirtualWorkspace";
    EnablementState[EnablementState["DisabledByExtensionDependency"] = 5] = "DisabledByExtensionDependency";
    EnablementState[EnablementState["DisabledGlobally"] = 6] = "DisabledGlobally";
    EnablementState[EnablementState["DisabledWorkspace"] = 7] = "DisabledWorkspace";
    EnablementState[EnablementState["EnabledGlobally"] = 8] = "EnabledGlobally";
    EnablementState[EnablementState["EnabledWorkspace"] = 9] = "EnabledWorkspace";
})(EnablementState || (EnablementState = {}))));
export { EnablementState, ExtensionInstallLocation, extensionsConfigurationNodeBase, getDefaultIconPath };
